var render = function render(_c,_vm){return _c('div',{staticClass:"d-flex flex-direction-row justify-content-center",style:(_vm.props.row.evolutionary_stage < 150
      ? 'background:green; color:white;'
      : _vm.props.row.evolutionary_stage > 250
      ? 'background:red; color:black;'
      : 'background:#F5BB27; color:black;')},[_vm._v("\n  "+_vm._s(_vm.props.row.evolutionary_stage)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }